import { jsx } from "react/jsx-runtime";
import { useContext, useMemo } from "react";
import assert from "assert";
import { TextContext } from "./TextContext.mjs";
import { useDefaultTextProps } from "../private/defaultTextProps.mjs";
import { textStyles } from "../../css/typography.mjs";
import { Typography } from "../private/Typography/Typography.mjs";
const Text = ({
  size: sizeProp,
  tone: toneProp,
  weight: weightProp,
  baseline = true,
  ...typographyProps
}) => {
  assert(
    !useContext(TextContext),
    "Text components should not be nested within each other"
  );
  const { size, weight, tone } = useDefaultTextProps({
    size: sizeProp,
    weight: weightProp,
    tone: toneProp
  });
  const textStylingProps = useMemo(
    () => ({
      tone,
      size,
      weight,
      baseline
    }),
    [tone, size, weight, baseline]
  );
  return /* @__PURE__ */ jsx(TextContext.Provider, { value: textStylingProps, children: /* @__PURE__ */ jsx(
    Typography,
    {
      ...typographyProps,
      className: textStyles(textStylingProps)
    }
  ) });
};
export {
  Text
};
